export default __webpack_public_path__ + "static/media/1471357552_location.e3f5e596.svg";